export const TRIAL_PAGES_DISCORD = 'discord';
